export default "__VITE_ASSET__BPxi4jcE__"